import React, { useState } from 'react';
import './OffersRenderer.css';

const OffersRenderer = ({ offers }) => {
    const [showNotes, setShowNotes] = useState(false);

    if (!offers || offers.length === 0) return null;

    const normalizeType = (o) => {
        if (!o || o.type === undefined || o.type === null) return '';
        if (typeof o.type === 'string') return o.type;
        return (o.type.name || o.type.displayName || '').toString();
    };

    const bannerOffers = offers.filter(o => normalizeType(o).toLowerCase() !== 'notes');
    const notesOffers = offers.filter(o => normalizeType(o).toLowerCase() === 'notes');

    return (
        <div className="or-root">
            {bannerOffers && bannerOffers.length > 0 && (
                <div className="or-banner">
                    {bannerOffers.map((b) => (
                        <div key={b.id} className="or-card">
                            {b.imageUrl && <div className="or-card-img" style={{ backgroundImage: `url(${b.imageUrl})` }} />}
                            <div className="or-card-body">
                                <div className="or-card-title">{b.title}</div>
                                {b.description && <div className="or-card-desc">{b.description}</div>}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {notesOffers && notesOffers.length > 0 && (
                <>
                    <button className="or-notes-fab" onClick={() => setShowNotes(true)} aria-label="Notes">
                        📌 <span className="or-notes-count">{notesOffers.length}</span>
                    </button>

                    {showNotes && (
                        <div className="or-notes-modal" role="dialog" aria-modal="true">
                            <div className="or-notes-panel">
                                <button className="or-notes-close" onClick={() => setShowNotes(false)}>✕</button>
                                <h3>Important Notes</h3>
                                <div className="or-notes-list">
                                    {notesOffers.map(n => (
                                        <div key={n.id} className="or-note">
                                            {n.title && <div className="or-note-title">{n.title}</div>}
                                            {n.description && <div className="or-note-desc">{n.description}</div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default OffersRenderer;
